import { Separator } from '@/components/ui/Separator';
import { CircleAlert, CircleCheck, CircleX, X } from 'lucide-react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router';
import { AppSidebar } from './AppSidebar';
import { ConfirmModalProvider } from './ConfirmModalProvider';
import { ModalProvider } from './ModalProvider';
import { ModeToggle } from './ModeToggle';
import { ThemeProvider } from './ThemeProvider';
import BreadcrumbsImp from './ui/Breadcrumb';
import { ErrorBoundaryFallbackRender } from './ui/ErrorBoundaryFallback';
import { SidebarInset, SidebarProvider, SidebarTrigger } from './ui/Sidebar';
import { Toaster } from './ui/Sonner';

const Layout = () => {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="sh-theme">
      <ModalProvider>
        <ConfirmModalProvider>
          <SidebarProvider>
            <ErrorBoundary fallbackRender={ErrorBoundaryFallbackRender}>
              <AppSidebar />
            </ErrorBoundary>
            <SidebarInset className="h-screen overflow-x-hidden overflow-y-auto">
              <header className="bg-background sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b px-4">
                <div className="flex flex-1 items-center gap-2 px-4">
                  <SidebarTrigger className="-ml-1" />
                  <Separator orientation="vertical" className="mr-2 h-4" />
                  <BreadcrumbsImp />
                  <div className="ms-auto">
                    <ModeToggle></ModeToggle>
                  </div>
                </div>
              </header>
              <div className="flex flex-1 flex-col gap-4 p-4">
                <Outlet />
              </div>
            </SidebarInset>
          </SidebarProvider>
        </ConfirmModalProvider>
      </ModalProvider>

      <Toaster
        icons={{
          success: <CircleCheck className="size-4" />,
          error: <CircleX className="size-4" />,
          warning: <CircleAlert className="size-4" />,
          close: <X className="size-4" />,
        }}
        toastOptions={{
          unstyled: true,
          closeButton: true,
          style: { width: '400px', maxHeight: 'unset', height: 'unset' },
          descriptionClassName: 'text-xs font-normal',
          className: 'flex border p-4 rounded-lg relative',
          classNames: {
            closeButton:
              'absolute top-2 right-2 hover:cursor-pointer text-muted-foreground hover:text-secondary-foreground',
            icon: 'me-[4px] mt-[2px] font-md',
            title: 'text-sm font-semibold',
            default: 'bg-background',
            success: 'text-green',
            error: 'text-red',
            warning: 'text-orange',
          },
        }}
      />
    </ThemeProvider>
  );
};

export default Layout;
